import { RicercaPraticheService } from 'src/app/services/ricerca-pratiche.service';
import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-general-email-modal',
  templateUrl: './general-email-modal.component.html',
  styleUrls: ['./general-email-modal.component.scss']
})
export class GeneralEmailModalComponent implements OnInit {

  // SALVA
  public buttonLabel: string = 'APPLICATION.BACK_OFFICE.RICERCA_PRATICA.MODAL.BUTTONS.SALVA';
  public form: FormGroup = this.formBuilder.group({
    emailBody: [null, [Validators.required, Validators.maxLength(2000)]],
    mail: [null],
    salvaBozza: [null]
  });
  public showExtraData = false;

  public date: Date = new Date();

  public salvaBozzaAttiva = false;

  public mailVisibile = true;

  ngOnInit() {
    if (this.data.params && this.data.params.body !== undefined && this.data.params.body !== null) {
      this.form.get('emailBody').patchValue(this.data.params.body);
    }
    if (this.data.config && this.data.config === 'extended') {
      this.showExtraData = true;
      this.form.get('mail').setValidators(Validators.required);
      this.form.get('mail').setValue(this.data.params.mail)
    }
    if (this.data.buttonLabel) this.buttonLabel = this.data.buttonLabel;
    
    if (this.salvaBozzaAttiva)
      this.ricercaPraticheService.getBozzaMailByIdPratica(this.data.idPratica).toPromise().then((response) => {
        console.log(response);
        if (response !== '')
          this.form.get('emailBody').setValue(response);
      });
    
  }

  constructor(
    public dialogRef: MatDialogRef<GeneralEmailModalComponent>,
    private ricercaPraticheService: RicercaPraticheService,
    @Inject(MAT_DIALOG_DATA) public data: { idPratica?: number, mailVisibile?: boolean, salvaBozzaAttiva?: boolean, header: string, buttonLabel?: string, text?: string, modalParam?: any, params?: { body: string, mail?: string }, config: 'plain' | 'extended' },
    private formBuilder: FormBuilder
  ) {
    if (data.salvaBozzaAttiva)
      this.salvaBozzaAttiva = data.salvaBozzaAttiva;
    if (!data.mailVisibile)
      this.mailVisibile = false;
    setInterval(() => {
      this.date = new Date();
    }, 60000);
  }



  onNoClick(): void {
    this.dialogRef.close();
  }

  getOutPutData() {
    if (this.showExtraData) {
      this.dialogRef.close(this.form.value);
    } else {
      this.dialogRef.close(this.form.get('emailBody').value);
    }
  }

  salvaBozza() {
    this.form.get('salvaBozza').setValue(true);
    this.dialogRef.close(this.form.value);
  }

}
